import React, { useEffect, useState, useMemo, useRef } from 'react';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { TableContainer } from "@mui/material";
import { Icon } from '@iconify/react';
import { DiamondPopUpFields } from 'Components/Pages/Gdev/Trading/Popup';
import { toPlainFields } from 'Components/Pages/Gdev/Trading/fieldconverter';
import Select, { components } from 'react-select';

const SingleDiamondPopup = ({ itemlist, addStone, index, onClose, onSave, allDiamondAttributes }) => {

    const [currentFieldIndex, setCurrentFieldIndex] = useState(0); // Track the index of the current field
    const inputRefs = useRef([]); // Store references for each input field

    const localfields = useMemo(() => toPlainFields(DiamondPopUpFields), []);

    const [itemfields, setItemfields] = useState(() => {
        // Initialize fields with defaults
        const updatedFields = localfields.map((localField) => ({
            ...localField,
            value: "", // Initialize value as empty string
            label: localField.label || "Default Label",
            placeholder: localField.placeholder || "Enter value",
            priority: localField.priority || 1,
            visibility: localField.visibility,
            place: localField.place,
        }));
        return updatedFields;
    });
    const customComponents = {
        DropdownIndicator: () => null,
    };
    const handleadditem = () => {
        const allWeightsValid = DiamondDetails.every(
            (stone) => parseFloat(stone.StoneWeight) > 0
        );

        if (!allWeightsValid) {
            alert("Please ensure all stones have a valid weight before adding a new one.");
            return;
        }

        setDiamondDetails((prevDetails) => [...prevDetails, addStone]);
        // setCurrentFieldIndex(0);

        const newFieldIndex = (DiamondDetails.length) * itemfields.length;
        setCurrentFieldIndex(newFieldIndex);


    };
    const [DiamondDetails, setDiamondDetails] = useState(itemlist[index]?.Diamonds || []);


    const shapeoptions = allDiamondAttributes.map(d => ({
        label: d.DiamondAttribute,
        value: d.Id
    }))
    const groupedDiamondAttributes = allDiamondAttributes.reduce((acc, attribute) => {
        const { DiamondAttribute, DiamondValue, Id } = attribute;
        if (!acc[DiamondAttribute]) {
            acc[DiamondAttribute] = [];
        }
        acc[DiamondAttribute].push({ label: DiamondValue, value: Id });
        return acc;
    }, {});

    const handleSave = () => {
        const isValid = DiamondDetails.every((stone, index) => {
            if (!stone.DiamondShape || !stone.DiamondShape.trim()) {
                alert(`Please add a DiamondShape for diamond at position ${index + 1}.`);
                return false;
            }
            if (!stone.DiamondWeight || parseFloat(stone.DiamondWeight) <= 0) {
                alert(`Please add a valid DiamondWeight for diamond at position ${index + 1}.`);
                return false;
            }
            return true;
        });

        if (!isValid) {
            return; // Stop saving if validation fails
        }
        onSave(DiamondDetails, 'diamond'); // Pass updated stone details to the parent
        onClose(); // Close the popup after saving
    };


    const handlevaluechange = (e, stoneIndex, fieldKey) => {
        const value = e.target.value;

        setDiamondDetails((prevDetails) => {
            const updatedDetails = [...prevDetails];
            const currentStone = updatedDetails[stoneIndex] || {};

            updatedDetails[stoneIndex] = {
                ...currentStone,
                [fieldKey]: value,
            };
            currentStone[fieldKey] = value;

            // Calculate DiamondAmount if DiamondWeight or DiamondRate changes
            if (fieldKey === "DiamondWeight" || fieldKey === "DiamondRate") {
                const weight = parseFloat(currentStone.DiamondWeight || 0); // Ensure numeric value
                const rate = parseFloat(currentStone.DiamondRate || 0); // Ensure numeric value
                currentStone.DiamondAmount = (weight * rate).toFixed(2); // Calculate amount and format to 2 decimals
            }

            updatedDetails[stoneIndex] = currentStone;


            //   if (fieldKey === "StoneName" && selectedStone) {

            //     console.log('StoneRateKarate:', currentStone.StoneRateKarate);
            //     console.log('StoneRate:', currentStone.StoneRate);
            //     console.log('Selected Stone:', selectedStone);


            //     // Autofill other fields
            //     updatedDetails[stoneIndex] = {
            //       ...selectedStone, // Use properties from stonemaster
            //       StoneRateKarate: parseFloat(selectedStone.StoneRateKarate) || parseFloat(selectedStone.StoneRate) || 0,

            //       StoneRatePiece: selectedStone.StoneRatePiece || 0,
            //       StoneAmount: selectedStone.StoneAmount || 0,
            //     };
            //   } else if (fieldKey === "StoneRateKarate") {
            //     const ratePerCarat = parseFloat(value) || 0;
            //     // const amount = ratePerCarat * (currentStone.StoneWeight || 0);
            //     const amount = (ratePerCarat * (currentStone.StoneWeight || 0)).toFixed(2);

            //     updatedDetails[stoneIndex] = {
            //       ...currentStone,
            //       StoneRateKarate: ratePerCarat,
            //       StoneRatePiece: 0, // Disable rate per piece
            //       StoneAmount: amount,
            //     };
            //   } else if (fieldKey === "StoneRatePiece") {
            //     const ratePerPiece = parseFloat(value) || 0;

            //     // const amount = ratePerPiece * (currentStone.StonePieces || 0);

            //     const amount = (ratePerPiece * (currentStone.StonePieces || 0)).toFixed(2);


            //     updatedDetails[stoneIndex] = {
            //       ...currentStone,
            //       StoneRatePiece: ratePerPiece,
            //       StoneRateKarate: 0, // Disable rate per carat
            //       StoneAmount: amount,
            //     };
            //   } else if (fieldKey === "StoneWeight") {
            //     const rawWeight = e.target.value; // Get the raw input
            //     const newWeight = parseFloat(value);
            //     const totalWeight = updatedDetails.reduce(
            //       (sum, stone, idx) => sum + (idx === stoneIndex ? newWeight : parseFloat(stone.StoneWeight) || 0),
            //       0
            //     );

            //     if (totalWeight > grossWeight) {
            //       alert(`Total StoneWeight cannot exceed GrossWeight (${grossWeight}).`);
            //       return prevDetails; // Do not update state if validation fails
            //     }

            //     const weight = parseFloat(value);
            //     // const amount = weight * (currentStone.StoneRateKarate || 0);

            //     const amount = (newWeight * (currentStone.StoneRateKarate || 0)).toFixed(2);


            //     // Update weight if validation passes
            //     updatedDetails[stoneIndex] = {
            //       ...currentStone,
            //       StoneWeight: rawWeight,
            //       // StoneRateKarate: ratePerCarat,
            //       // StoneRatePiece: 0, // Disable rate per piece
            //       StoneAmount: amount,

            //       // [fieldKey]: value,
            //     };
            //   }
            //   else if (fieldKey === "StonePieces") {
            //     // const ratePerPiece = parseFloat(value) || 0;
            //     // const amount = ratePerPiece * (currentStone.StonePieces || 0);
            //     const pieces = parseFloat(value) || 0;

            //     // const rp = pieces * (currentStone.StoneRatePiece || 0);

            //     const amount = (pieces * (currentStone.StoneRatePiece || 0)).toFixed(2);


            //     updatedDetails[stoneIndex] = {
            //       ...currentStone,
            //       StonePieces: pieces,
            //       // StoneRatePiece: pieces,
            //       // StoneRateKarate: 0, // Disable rate per carat
            //       StoneAmount: amount,
            //     };
            //   }

            //   else {
            //     updatedDetails[stoneIndex] = {
            //       ...currentStone,
            //       [fieldKey]: value,
            //     };
            //   }

            console.log('check updatestone...', updatedDetails);

            return updatedDetails;
        });
    };



    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <div className="modal-header">
                    <p style={{ fontSize: "14px", fontWeight: "bold" }}>
                        Add Diamond Details
                    </p>
                    <Icon
                        style={{
                            cursor: "pointer",
                            fontSize: "20px",
                            color: "#627282",
                        }}
                        icon="carbon:close-filled"
                        onClick={onClose} // Close the modal
                    />
                </div>
                <table className="diamond-table">
                    <thead>
                        <tr>
                            {/* Render dynamically generated headers */}
                            {itemfields
                                .filter(field => field.place === 'top' && field.visibility !== 'Hidden' && field.IsVisible)
                                .sort((a, b) => a.priority - b.priority)
                                .map(field => (
                                    <th key={field.key}>

                                        {field.key === 'ActionPlus' ? (
                                            <>
                                                {/* Action */}
                                                <FaPlus
                                                    style={{
                                                        marginLeft: '8px',
                                                        cursor: 'pointer',
                                                        height: '20px',
                                                        width: '20px',
                                                        color: '#4CAF50', // Customize icon color
                                                    }}
                                                    onClick={() => {
                                                        handleadditem()
                                                        // Add row functionality here
                                                    }}
                                                />
                                            </>
                                        ) : (
                                            field.label || field.key
                                        )}
                                    </th>
                                ))}

                        </tr>
                    </thead>
                    <tbody>
                        {DiamondDetails.map((stone, stoneIndex) => (
                            <tr key={stoneIndex}>
                                {itemfields
                                    .filter(field => field.place === "top" && field.visibility !== "Hidden" && field.IsVisible)
                                    .sort((a, b) => a.priority - b.priority)
                                    .map((field, fieldIndex) => {
                                        const value = stone[field.key] || ""; // Get value for this stone detail
                                        console.log('stonefieldkey ', field.key);

                                        return (

                                            <td key={field.key}>
                                                {field.type === "inputnumber" ||
                                                    field.type === "inputtext" ||
                                                    field.type === "inputdecimal" ? (
                                                    <input
                                                        type={
                                                            field.type === "inputnumber" || field.type === "inputdecimal"
                                                                ? "number"
                                                                : "text"
                                                        } // Use appropriate input type
                                                        step={field.type === "inputdecimal" ? "0.01" : "1"} // Handle decimal precision
                                                        value={value} // Bind input to normalized value
                                                        className="AddStock-input"
                                                        ref={(el) => {
                                                            const refKey = `${stoneIndex}-${field.key}`;
                                                            inputRefs.current[refKey] = el;
                                                        }}
                                                        onFocus={() => {
                                                            const fieldIndex = stoneIndex * itemfields.length + itemfields.findIndex(f => f.key === field.key);
                                                            setCurrentFieldIndex(fieldIndex); // Update to the correct field index
                                                        }}
                                                        // disabled={field.visibility}
                                                        onChange={(e) => handlevaluechange(e, stoneIndex, field.key)}
                                                    />
                                                ) : field.type === "inputselect" ? (
                                                    <div key={field.key}>
                                                        <Select
                                                            list={field.key}
                                                            // className="adminAddCategoryMainBox2-input"
                                                            className="basic-single"
                                                            components={customComponents}
                                                            value={
                                                                groupedDiamondAttributes[field.key]?.find(
                                                                  (option) => option.label === value
                                                                ) || null
                                                              } // Match current value to options
                                                            options={groupedDiamondAttributes[field.key] || []}
                                                            ref={(el) => {
                                                                const refKey = `${stoneIndex}-${field.key}`;
                                                                inputRefs.current[refKey] = el;
                                                            }}
                                                            onFocus={() => {
                                                                const fieldIndex = stoneIndex * itemfields.length + itemfields.findIndex(f => f.key === field.key);
                                                                setCurrentFieldIndex(fieldIndex); // Update to the correct field index
                                                            }}
                                                            onChange={(selectedOption) => handlevaluechange({ target: { value: selectedOption.label } }, stoneIndex, field.key)}
                                                        // onChange={(e) => handlevaluechange(e, stoneIndex, field.key)}
                                                        />

                                                    </div>
                                                )
                                                    : field.type === "Icon" ? (
                                                        <div key={field.key}>
                                                            <FaTrash
                                                                style={{
                                                                    marginLeft: '8px',
                                                                    cursor: 'pointer',
                                                                    // color: '#4CAF50', // Customize icon color
                                                                }}
                                                                onClick={() => {
                                                                    handleDeleteStone(stoneIndex)
                                                                    // Add row functionality here
                                                                }}
                                                            />

                                                        </div>
                                                    ) : (
                                                        null
                                                    )}
                                            </td>
                                        );
                                    })}
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>

                            {itemfields
                                .filter(field => field.place === "top" && field.visibility !== "Hidden" && field.IsVisible)
                                .sort((a, b) => a.priority - b.priority)
                                .map(field => {

                                    return (
                                        <td key={field.key}>
                                            {field.key === 'StoneWeight'
                                                ? DiamondDetails.reduce((total, stone) => total + parseFloat(stone.StoneWeight || 0), 0).toFixed(3)
                                                : field.key === 'StonePieces'
                                                    ? DiamondDetails.reduce((total, stone) => total + (parseInt(stone.StonePieces, 10) || 0), 0)
                                                    : field.key === 'StoneAmount'
                                                        ? DiamondDetails.reduce((total, stone) => total + (parseFloat(stone.StoneAmount || 0) || 0), 0).toFixed(2)
                                                        : null}
                                        </td>
                                    )
                                })}
                        </tr>
                    </tfoot>
                </table>
                <div className="modal-footer">
                    <button onClick={handleSave} className="save-button">Save</button>
                    <button onClick={onClose} className="cancel-button">Cancel</button>
                </div>
            </div>
        </div>
    );
}

export default SingleDiamondPopup;